export enum StatusCode {
  // Account Status Codes
  OK = 0,
  ACCOUNT_CLOSED = 'accountClosed',
  ACCOUNT_CLOSED_PV = 'accountClosedPv',
  ACCOUNT_REVALIDATION_REQUIRED = 'forceReAuthentication',
  APC_ON_DIFF_DEVICE = 'APCOnDiffDevice',
  ARCHIVED = 'archived',
  BAD_FORMAT = 'BAD_FORMAT',
  BIRTHDAY_INVALID = 'birthdayInvalid',
  BIRTHDAY_REQUIRED = 'birthdayRequired',
  BLOCKED_BANNED_BY_REGULATOR = 'bannedByRegulator',
  BLOCKED_REVAL_REQD = 'loginBlockedRevalidationRequired',
  EMAIL_NOT_ALLOWED = 'emailLoginError',
  ERR_VIPSTORE_UNIQUE_ROLL_USED = 'ERR_VIPSTORE_UNIQUE_ROLL_USED',
  ERROR_TYPO = 'typo',
  FORBIDDEN = 'FORBIDDEN',
  INTERNAL = 'INTERNAL',
  LICENSE_MISMATCH = 'licenseMismatch',
  LOGIN_ALREADY_LOGGEDIN = 'alreadyLoggedin',
  LOGIN_BLOCKED_BY_GEO_IP = 'blockedByGeoIp',
  LOGIN_CASHIER_CLOSED = 'cashierIsClosed',
  LOGIN_COOL_OFF = 'loginCoolOffLimit',
  LOGIN_EXPLICIT_LOGIN_DK_REQUIRED = 'explicitLoginDKRequired',
  LOGIN_INTERNAL = 'internalError',
  LOGIN_INVALID_CREDENTIALS = 'invalidCredentials',
  LOGIN_LIMIT_REACHED = 'limitReached',
  LOGIN_NOT_ALLOWED = 'notAllowed',
  LOGIN_NOT_EMAIL_VERIFIED = 'notEmailVerified',
  LOGIN_NOT_REALMONEYOK = 'notRealMoneyOk',
  LOGIN_SELF_EXCLUDED = 'selfExcluded',
  LOGIN_STRONG_AUTH_REQUIRED = 'strongAuthRequired',
  LOGIN_TIME_LIMIT_REACHED = 'timeLimitReached',
  LOGIN_TOTAL_LIMIT_REACHED = 'totalLimitReached',
  LONG_SESSION_COOL_OFF = 'longSessionCoolOff',
  MITID_AUTH_REQUIRED = 'mitIdAuthRequired',
  MITID_AUTH_FAILED = 'mitIdAuthFailed',
  TRANSFER_APC_NOT_READY = 'transferAPCNotReady',
  NOT_ENOUGH_FPP = 'NOT_ENOUGH_FPP',
  NOT_FOUND = 'NOT_FOUND',
  PANIC_BUTTON_EXCLUDED = 'panicButtonExcluded',
  PIN_INVALID = 'pinInvalid',
  PIN_REQUIRED = 'pin',
  POW_REQUIRED = 'POW',
  PREVENT_LOGIN = 'preventLogin',
  RSA_INVALID_CREDENTIALS = 'rsaInvalidCredentials',
  RSA_NOT_ALLOWED = 'RSAnotAllowed',
  RSA_REQUIRED = 'rsa',
  RSA_TOKEN_DISABLED = 'rsaTokenDisabled',
  SITE_MISMATCH = 'siteMismatch',
  SMS_VALIDATION_REQUIRED = 'smsValidationRequired',
  TEMP_PIN_REQUIRED = 'temppin',
  TEMP_PIN_REQUIRED_SMS = 'temppinsms',
  TIMEOUT = 'TIMEOUT',
  TMP_PWD_EXPIRED = 'tempPwdExpired',
  UNAUTHORIZED = 'UNAUTHORIZED',
  UNKNOWN = 'UNKNOWN',
  USER_EULA_REQUIRED = 'EULA',
  USER_IN_LIMITED_MODE = 'userInLimitedMode',
  VALIDATION_ERROR = 'VALIDATION_ERROR',
  // Casino Status Codes
  // @TODO refactor to strings
  SYSTEM_ERROR = 1,
  INPUT_ERROR = 2,
  BUSY_ERROR = 3,
  SHUTDOWN_ERROR = 4,
  AUTH_ERROR = 5,
  NO_SESSION_ERROR = 6,
  OBSOLETE_ERROR = 7,
  SESSION_AUTH_ERROR = 8,
  SESSION_CLOSED_ERROR = 9,
  TIMEOUT_ERROR = 10,
  ALREADY_PLAYING_ERROR = 11,
  INTERRUPTED_GAME_ERROR = 12,
  GAME_UNAVAILABLE = 13,
  SLOT_LIMIT_EXCEEDED = 14,
  CONCURRENT_LOGIN = 15,
  REQUEST_NOT_FOUND = 16,
  INVALID_EMAIL = 17,
  HAND_HISTORY_ERROR = 18,
  MULTI_PLATFORM_LOGIN = 19,
  NO_COUNTRY = 20,
  NOT_ALLOWED = 21,
  UNFINISHED_GAMES_ON_ANOTHER_DEVICE = 22,
  FSB_ALREADY_IN_PROGRESS = 23,
  IGT_INTERRUPTED_GAME_ERROR = 24,
  RACE_ALREADY_PLAYING_ERROR = 27,
  NO_TOURNAMENTS = 31,
  RACE_FINISHED = 33,
  DUPLICATE_NEW_USER_EMAIL = 35,
  RACE_ONLY_ONE_AT_A_TIME = 39,
  RACE_PROMO_BAN = 44,
  RACE_BLOCKED_IN_COUNTRY = 45,
  BALANCE_PENDING_BONUS_ERROR = 56,
  SUCCESSFUL_DEPOSIT_LIMIT = 65,
  DEPOSIT_LIMIT_ALREADY_REQUESTED = 73,
  DEPOSIT_LIMIT_REQUEST_PROCESSING = 80,
  DEPOSIT_LIMIT_INCREASE_DENIED = 82,
  HAND_NOT_FOUND = 95,
  WRONG_PWD = 100,
  ALREADY_SELF_EXCLUDED_ERROR = 147,
  EMAIL_ALREADY_EXISTS = 170,
  ALREADY_REQUESTED = 174,
  INVALID_PHONE = 172,
  SERVICE_NOT_AVAILABLE = 204,
  BALANCE_PENDING_TRANSACTION_ERROR = 211,
  BALANCE_NOT_EMPTY_ERROR = 236,
  CLIENT_NOT_AVAILABLE_FOR_COUNTRY = 258,
  ERR_COUNTRY_RESTRICTED = 269,
  UNVALIDATED_EMAIL = 293,
  STAR_CODE_INVALID = 392,
  STAR_CODE_MAX_NUMBER_OF_PLAYERS_ALREADY_USED = 394,
  STAR_CODE_ALREADY_SUBMITTED = 395,
  STAR_CODE_INVALID_DATE = 396,
  ERR_DUPLICATE_REQUEST = 480,
  STAR_CODE_CANNOT_BE_USED = 483,
  COOLING_PERIOD_IN_EFFECT = 512,
  ERR_TRY_AGAIN = 539,
  REGISTRATION_BLOCKED_BY_GEO_IP = 754,
  SECURITY_CODE_VALIDATION_FAILED = 758,
  INCREASE_LIMIT_NOT_ALLOWED = 796,
  SELFEXCLUSION_INVALID_VALUE = 821,
  SMS_VALIDATION_ENABLED = 1002
}

export enum StatusSubcode {
  AUTH_SUB_ERROR_NONE = 0,
  AUTH_SUB_AUTH_ERROR_ACCOUNT_CLOSED = 11,
  AUTH_SUB_ERROR_ACCOUNT_CLOSED_2 = 20
}
